import React, { useEffect, useState, useRef } from 'react';
import { Box, Flex, Spinner, Text, Image, useToast } from '@chakra-ui/react';
import { getProjectFileApi } from '../dashboardapi';
import PdfViewer from "./PdfViewer";

const FileViewer = ({ projectId, file }) => {
    const [fileContent, setFileContent] = useState(null);
    const [loading, setLoading] = useState(false);
    const toast = useToast();
    const pdfContainerRef = useRef(null);

    useEffect(() => {
        const loadFile = async () => {
            if (!file || !file.file_uuid) return;
            setLoading(true);
            try {
                const res = await getProjectFileApi(projectId, file.file_uuid);
                if (res.data && res.data.content) {
                    const base64Content = res.data.content;
                    let url;
                    if (file.name.toLowerCase().endsWith('.pdf')) {
                        url = `data:application/pdf;base64,${base64Content}`;
                    } else {
                        const ext = file.name.split('.').pop().toLowerCase();
                        let mime = 'image/jpeg';
                        if (ext === 'png') mime = 'image/png';
                        else if (ext === 'svg') mime = 'image/svg+xml';
                        else if (ext === 'gif') mime = 'image/gif';
                        else if (ext === 'webp') mime = 'image/webp';
                        url = `data:${mime};base64,${base64Content}`;
                    }
                    setFileContent(url);
                } else {
                    toast({
                        title: "Error loading file",
                        description: "File content not available",
                        status: "error",
                        duration: 2000,
                        isClosable: true
                    });
                }
            } catch (error) {
                console.error(error);
                toast({
                    title: "Error loading file",
                    description: "Could not load file content",
                    status: "error",
                    duration: 2000,
                    isClosable: true
                });
            } finally {
                setLoading(false);
            }
        };

        loadFile();
    }, [projectId, file?.file_uuid, file?.name]);

    if (loading) return (
        <Flex h="100%" justify="center" align="center" direction="column" bg="#1e1e1e" color="#cccccc">
            <Spinner size="xl" />
            <Text mt={4}>Loading...</Text>
        </Flex>
    );

    if (!fileContent) return (
        <Flex h="100%" justify="center" align="center" bg="#1e1e1e" color="#cccccc">
            <Text>No content to display</Text>
        </Flex>
    );

    const isPdf = file.name.toLowerCase().endsWith('.pdf');

    return (
        <Box flex={1} overflow="hidden" display="flex" justifyContent="center" bg="#1e1e1e" position="relative" h="100%" w="100%" ref={pdfContainerRef}>
            {isPdf ? (
                <PdfViewer
                    data={fileContent}
                    toggleEditor={() => { }}
                    pdfFull={true}
                    pdfContainer={pdfContainerRef}
                    prevScroll={0}
                />
            ) : (
                <Image src={fileContent} w="100%" h="100%" objectFit="contain" />
            )}
        </Box>
    );
};

export default FileViewer;
